import React, { useEffect, useState } from 'react';
import { ReportingShellContainerBaseConfig } from '../../base';
import {
    ReportingSidebarContainerProps,
    ReportingSidebarControllerProps,
} from './reportingSidebarProps';
import {
    ReportingSidebarController,
    ReportingSidebarLoader,
    ReportingSidebarStateProvider,
} from './reportingSidebarInterface';
import { HiOutlineHome } from 'react-icons/hi';
import { GoWorkflow } from 'react-icons/go';

export function createReportingSidebarContainer(
    config: ReportingShellContainerBaseConfig &
        Pick<ReportingSidebarControllerProps, 'navigation'>,
    loader: ReportingSidebarLoader,
    controller: ReportingSidebarController
): React.FC<ReportingSidebarContainerProps> {
    const {
        context: { useContext },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, containerProps);
        const state = config.state.layout.useState(context);
        const [sidebarWidthLocal, setSidebarWidthLocal] = useState(
            state.value.sidebarWidth
        );

        const viewProps = controller.useProps(context, data, {
            ...containerProps,
            width: {
                value: sidebarWidthLocal,
                onChange(value) {
                    setSidebarWidthLocal(value);
                    state.onChange({ ...state.value, sidebarWidth: value });
                },
            },
            navigation: {
                items: config.navigation.items,
            },
        });

        return <View {...viewProps} />;
    };
}
